import { render, staticRenderFns } from "./MultipleAnswer.vue?vue&type=template&id=d689a4da&scoped=true&"
import script from "./MultipleAnswer.vue?vue&type=script&lang=js&"
export * from "./MultipleAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAnswer.vue?vue&type=style&index=0&id=d689a4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d689a4da",
  null
  
)

export default component.exports